import React from "react";
import Wrapper from "../layout/Wrapper";
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";

const Grid = styled.div`
  ${breakpoint("tablet")`
    display: flex;
  `}
`;

const Marca = styled.div`
  margin-right: ${props => props.theme.space[3]}px;
  width: 80px;
  font-size: 12px;
  height: 60px;
  display: flex;
`;

const Hr = styled.div`
  width: 100%;
  height: 1px;
  background: ${props => props.theme.colors.grisClaro};
  margin-top: ${props => props.theme.space[5]}px;
`;

export default ({ marcas }) => (
  <Wrapper>
    <Hr />
    <h3>Marcas</h3>
    <Grid>
      {marcas.map(marca => (
        <Marca>
          <img src={marca.logo.file.url} alt={marca.nombre} />
        </Marca>
      ))}
    </Grid>
  </Wrapper>
);
